// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../TypeUtils.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var GraphQL_PPX = require("@reasonml-community/graphql-ppx/bucklescript/GraphQL_PPX.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var CommonTypes_User_Name = require("../CommonTypes_User_Name.bs.js");
var CommonTypes_LongPhoneNumber = require("../CommonTypes_LongPhoneNumber.bs.js");

var include = TypeUtils.MakeOpaqueIntType({});

var fromInt = include.fromInt;

var toInt = include.toInt;

var compare = include.compare;

var eq = include.eq;

function parse(param) {
  return Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: toInt
};

var Id_fromString = include.fromString;

var Id_toString = include.toString;

var Id_decode = include.decode;

var Id_encode = include.encode;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromInt: fromInt,
  fromString: Id_fromString,
  toInt: toInt,
  toString: Id_toString,
  decode: Id_decode,
  encode: Id_encode,
  compare: compare,
  eq: eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  GraphQL_API: GraphQL_API
};

var Raw = {};

var query = "fragment CommonTypes_Business_Manager on User   {\n...CommonTypes_User_Name   \nid  \nphoneNumber  \n}\n" + CommonTypes_User_Name.query;

function parse$1(value) {
  var param = value["id"];
  return {
          commonTypes_User_Name: CommonTypes_User_Name.verifyArgsAndParse("CommonTypes_User_Name", value),
          id: Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, param),
          phoneNumber: value["phoneNumber"]
        };
}

function serialize(value) {
  var value$1 = value.phoneNumber;
  var value$2 = value.id;
  var value$3 = Curry._1(toInt, value$2);
  return [CommonTypes_User_Name.serialize(value.commonTypes_User_Name)].reduce(GraphQL_PPX.deepMerge, {
              id: value$3,
              phoneNumber: value$1
            });
}

function verifyArgsAndParse(_CommonTypes_Business_Manager, value) {
  return parse$1(value);
}

function verifyName(param) {
  
}

function make(firstName, id, lastName, phoneNumber) {
  return {
          id: id,
          name: CommonTypes_User_Name.make(firstName, lastName),
          phoneNumber: phoneNumber
        };
}

function tToR(param) {
  var id = param.id;
  var name = param.commonTypes_User_Name;
  return Relude_Option.map((function (phoneNumber) {
                return {
                        id: id,
                        name: name,
                        phoneNumber: phoneNumber
                      };
              }), CommonTypes_LongPhoneNumber.fromString(param.phoneNumber));
}

function compare$1(param, param$1) {
  return Curry._2(compare, param.id, param$1.id);
}

function compareByName(param, param$1) {
  var other = Curry._2(CommonTypes_User_Name.compare, param.name, param$1.name);
  if (other === "equal_to") {
    return Curry._2(compare, param.id, param$1.id);
  } else {
    return other;
  }
}

function eq$1(param, param$1) {
  return Curry._2(eq, param.id, param$1.id);
}

var Ord = {
  compare: compare$1,
  eq: eq$1
};

var $$Set = Relude_Set.WithOrd({
      eq: eq$1,
      compare: compare$1
    });

function eq$2(param, param$1) {
  return Relude_Option.eqBy(eq$1, param, param$1);
}

function compare$2(param) {
  var a = param[0];
  if (a === undefined) {
    if (param[1] !== undefined) {
      return "less_than";
    } else {
      return "equal_to";
    }
  }
  var b = param[1];
  if (b !== undefined) {
    return compare$1(a, b);
  } else {
    return "greater_than";
  }
}

function compare$3(param, param$1) {
  return Relude_Function.curry2(compare$2, param, param$1);
}

var include$1 = Relude_Set.WithOrd({
      eq: eq$2,
      compare: compare$3
    });

var fromList = include$1.fromList;

var partial_arg = Relude_List.map(Relude_Option.pure);

function partial_arg$1(param) {
  return Relude_Globals.$great$great($$Set.toList, partial_arg, param);
}

function partial_arg$2(param) {
  return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                return Relude_List.prepend(undefined, param);
              }), param);
}

function fromSet(param) {
  return Relude_Globals.$great$great(partial_arg$2, fromList, param);
}

var SetWithNone_Comparable = include$1.Comparable;

var SetWithNone_empty = include$1.empty;

var SetWithNone_fromArray = include$1.fromArray;

var SetWithNone_isEmpty = include$1.isEmpty;

var SetWithNone_contains = include$1.contains;

var SetWithNone_add = include$1.add;

var SetWithNone_mergeMany = include$1.mergeMany;

var SetWithNone_remove = include$1.remove;

var SetWithNone_removeMany = include$1.removeMany;

var SetWithNone_update = include$1.update;

var SetWithNone_toggle = include$1.toggle;

var SetWithNone_union = include$1.union;

var SetWithNone_intersect = include$1.intersect;

var SetWithNone_diff = include$1.diff;

var SetWithNone_subset = include$1.subset;

var SetWithNone_compare = include$1.compare;

var SetWithNone_eq = include$1.eq;

var SetWithNone_forEach = include$1.forEach;

var SetWithNone_foldLeft = include$1.foldLeft;

var SetWithNone_foldRight = include$1.foldRight;

var SetWithNone_all = include$1.all;

var SetWithNone_any = include$1.any;

var SetWithNone_filter = include$1.filter;

var SetWithNone_keep = include$1.keep;

var SetWithNone_filterNot = include$1.filterNot;

var SetWithNone_reject = include$1.reject;

var SetWithNone_partition = include$1.partition;

var SetWithNone_length = include$1.length;

var SetWithNone_toArray = include$1.toArray;

var SetWithNone_toList = include$1.toList;

var SetWithNone_minimum = include$1.minimum;

var SetWithNone_maximum = include$1.maximum;

var SetWithNone_get = include$1.get;

var SetWithNone_getOrElse = include$1.getOrElse;

var SetWithNone_split = include$1.split;

var SetWithNone = {
  Comparable: SetWithNone_Comparable,
  empty: SetWithNone_empty,
  fromArray: SetWithNone_fromArray,
  fromList: fromList,
  isEmpty: SetWithNone_isEmpty,
  contains: SetWithNone_contains,
  add: SetWithNone_add,
  mergeMany: SetWithNone_mergeMany,
  remove: SetWithNone_remove,
  removeMany: SetWithNone_removeMany,
  update: SetWithNone_update,
  toggle: SetWithNone_toggle,
  union: SetWithNone_union,
  intersect: SetWithNone_intersect,
  diff: SetWithNone_diff,
  subset: SetWithNone_subset,
  compare: SetWithNone_compare,
  eq: SetWithNone_eq,
  forEach: SetWithNone_forEach,
  foldLeft: SetWithNone_foldLeft,
  foldRight: SetWithNone_foldRight,
  all: SetWithNone_all,
  any: SetWithNone_any,
  filter: SetWithNone_filter,
  keep: SetWithNone_keep,
  filterNot: SetWithNone_filterNot,
  reject: SetWithNone_reject,
  partition: SetWithNone_partition,
  length: SetWithNone_length,
  toArray: SetWithNone_toArray,
  toList: SetWithNone_toList,
  minimum: SetWithNone_minimum,
  maximum: SetWithNone_maximum,
  get: SetWithNone_get,
  getOrElse: SetWithNone_getOrElse,
  split: SetWithNone_split,
  fromSet: fromSet
};

function make$1(firstName, lastName, phoneNumber) {
  return {
          firstName: firstName,
          lastName: lastName,
          phoneNumber: phoneNumber
        };
}

function makeFromExisting(param) {
  var match = param.name;
  return {
          firstName: match.firstName,
          lastName: match.lastName,
          phoneNumber: param.phoneNumber
        };
}

var New = {
  make: make$1,
  makeFromExisting: makeFromExisting
};

exports.Id = Id;
exports.Raw = Raw;
exports.query = query;
exports.parse = parse$1;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.make = make;
exports.tToR = tToR;
exports.compare = compare$1;
exports.compareByName = compareByName;
exports.eq = eq$1;
exports.Ord = Ord;
exports.$$Set = $$Set;
exports.SetWithNone = SetWithNone;
exports.New = New;
/* include Not a pure module */
